export default "__VITE_ASSET__CATZSoGX__"